import React from "react";
import { SensorType, TypeCamaras, TypeSensor, TypeValor } from '../../pages/camaras/interface/camara.interface';
import { valores } from "../../api/valores";
import moment from "moment";
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import CrosshairPlugin from 'chartjs-plugin-crosshair';

import imageFlechaAvanza from '../images/Flecha_Avanza_X1.jpg'
import imageFlechaRetrocede from '../images/Flecha_Retrocede_X1.jpg'
import imageInicial from '../images/Inicial.jpg'
import imageZoom from '../images/Zoom.jpg'
import imageReloj from '../images/Reloj.jpg'
import imageEje from '../images/Ejes.jpg'
import imageSeleccionar from '../images/Seleccionar.jpg'
import imagePuntosValores from '../images/PuntosValores.jpg'
import imageRegla from '../images/Regla.jpg'



type CardProps = {
    propsCamara: TypeCamaras;
}


export const GraficoComponent: React.FC<CardProps> = ({propsCamara}) => {

  const chartRef = React.useRef<ChartJS<"line", TypeValor[], string>>(null);

  const [allValor, setValor] = React.useState<TypeSensor[] | null>([]);

  const [loading, setLoading] = React.useState<boolean>(true);  
 
  /*var startDb:Date =  moment().subtract(48,'hour').toDate();
  var startChart:Date =  moment().subtract(24,'hour').toDate();
  var end:Date =  moment().toDate();*/

  const [startDb, setStartDb] = React.useState<Date>(moment().subtract(48, 'hour').toDate());
  const [endDb, setEndDb] = React.useState<Date>(moment().toDate());
  const [startChart, setStartChart] = React.useState<Date>(moment().subtract(24, 'hour').toDate());
  const [endChart, setEndChart] = React.useState<Date>(moment().toDate());

  const [maxEjeY, setMaxEjeY] = React.useState<number | undefined>(undefined);
  const [minEjeY, SetMinEjeY] = React.useState<number | undefined>(undefined);
  const [nombreEjeY, SetNombreEjeY] = React.useState<string | undefined>(" ");

  const [zoomEnabled, setZoomEnabled] = React.useState(false);
  const [reglaEnabled, setReglaEnabled] = React.useState(true);
  const [tooltipEnabled, setTooltipEnabled] = React.useState(true);
  const [AutoEjeYEnabled, setAutoEjeYEnabled] = React.useState(false);


  // 👉 Estado para ventana de selección de fecha
  const [openDialog, setOpenDialog] = React.useState(false);
  const [tempStart, setTempStart] = React.useState<Date>(moment().subtract(24, 'hour').toDate());
  const [tempEnd, setTempEnd] = React.useState<Date>(moment().toDate());

  const timerRef = React.useRef<NodeJS.Timeout | null>(null);

  const CustomCrosshairPlugin = function (plugin: any) {  
    const originalAfterDraw = plugin.afterDraw;  
    plugin.afterDraw = function(chart: any, easing: any) {  
        if (chart && chart.crosshair) {  
          originalAfterDraw.call(this, chart, easing);  
        }  
    };  
    return plugin;  
  };

  const getNombreEje = (tipo: SensorType) => {
    switch (tipo) {
      case 'TEMPERATURA':
        return "Temperatura [°C]";
      case 'PRESION': 
        return "Presion [Kg]";
      case 'POTENCIA':
        return "Potencia [KW]";
      default:
        return " ";
    }   
  };

  React.useEffect(() => {
      setLoading(true); 
      valores
      .getbyCamaraId(propsCamara.id, startDb, endDb)
      .then((r) => {
          setValor(r.data.data);
          setMaxEjeY(r.data.data[0].max_grafico);
          SetMinEjeY(r.data.data[0].min_grafico);
          SetNombreEjeY(getNombreEje(r.data.data[0].tipo_sensor));
        
          setTimeout(() => setLoading(false), 50); //Una vez que la data cargo a loa 300ms se renderizan el grafico           
        })
        .catch((err) => {
          console.error(err);
        });

  }, [propsCamara.id, startDb, endDb]);

  // 🔹 Efecto de limpieza (colocarlo al final de los useEffect)
React.useEffect(() => {
  return () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
}, []);



  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale,
    zoomPlugin,
    CustomCrosshairPlugin(CrosshairPlugin),
  );

  async function fetchData(x1: Date, x2: Date) : Promise<TypeSensor[] | null> {
    try {;
      const r = await valores.getbyCamaraId(propsCamara.id, x1, x2);
      console.log("datos en fechdata", r.data.data)
      return r.data.data;
    } catch (error) {
      return [];
    }
  }

  function startFetch(chart: any, event?: MouseEvent) {
    event?.stopPropagation();
    event?.preventDefault();
    const min = moment(chart.scales.x.min).toDate(); // ✅ chart.scales.x.min (sin .chart)
    const max = moment(chart.scales.x.max).toDate(); 
    
    if (min < startDb) {
      if (timerRef.current) 
        clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        let newStart = startDb;
        
        while (min < newStart) {
          newStart = moment(newStart).subtract(48, 'hour').toDate();
        }

        // ✅ Actualizamos el estado (React re-renderiza)
        setStartDb(newStart);
        setEndDb(max);

        //Actualizamos la vista mínima (startChart) al mínimo actual de la escala
        setStartChart(min);
        setEndChart(max);

        try {
        const r = await fetchData(startDb, endDb);
        if (!r || !chartRef.current) return;

        // ✅ Actualizamos el estado React primero
        setValor(r);

        // ✅ Esperamos a que React renderice antes de tocar Chart.js
        requestAnimationFrame(() => {
          const chartInstance = chartRef.current;
          if (
            chartInstance &&
            chartInstance.canvas &&
            chartInstance.canvas.ownerDocument
          ) {
            chartInstance.update("none");
          } else {
            console.warn(
              "⚠️ Chart update skipped because canvas was detached (DevTools open?)"
            );
          }
        });
      } catch (err) {
        console.error("Error updating chart:", err);
      }

      }, 200);
    }

    if (max > endDb) {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        let newEnd = endDb;
        
        while (max > newEnd) {
          newEnd = moment(newEnd).add(48, 'hour').toDate();
        }

        // ✅ Actualizamos el estado (React re-renderiza)
        setStartDb(min);
        setEndDb(newEnd);

        //Actualizamos la vista mínima (startChart) al mínimo actual de la escala
        setStartChart(min);
        setEndChart(max);

        try {
          const r = await fetchData(startDb, endDb);
          if (!r || !chartRef.current) return;

          // ✅ Actualizamos el estado React primero
          setValor(r);

          // ✅ Esperamos a que React renderice antes de tocar Chart.js
          requestAnimationFrame(() => {
            const chartInstance = chartRef.current;
            if (
              chartInstance &&
              chartInstance.canvas &&
              chartInstance.canvas.ownerDocument
            ) {
              chartInstance.update("none");
            } else {
              console.warn(
                "⚠️ Chart update skipped because canvas was detached (DevTools open?)"
              );
            }
          });
        } catch (err) {
          console.error("Error updating chart:", err);
        }

      }, 200);
    }
  }  

  const dataValores = { 
    datasets: 
        allValor!.map((sensor) => ({
          label: `${sensor.name_front}`, /*`${sensor.name_front} (${sensor.descripcion})`*/
          data: sensor.valores,
          parsing: {
            xAxisKey: 'fecha_hora_value',
            yAxisKey: 'value'
          },
          fill: false,
          backgroundColor: sensor.color_front,
          borderColor: sensor.color_front,  
        })
     )
    };



  const scales = {
    x: {
     // position: 'bottom' as const,
      min: startChart.toISOString()/*.toString()*/,
      max: endChart.toISOString()/*.toString()*/,
      type: 'time' as const,
     // distribution: "series" as const,
      ticks: {
        autoSkip: true,
        autoSkipPadding: 50,
        maxRotation: 0,
        color: 'rgb(0,0,0)' ,
        font: {
        size: window.innerWidth < 600 ? 10 : window.innerWidth < 1200 ? 12 : 14,
        weight: "bold" as const,
      },
      },
      time: {
        units: "hour",
        displayFormats: {
          hour: "DD/MM/YYYY HH:mm",
          minute: 'DD/MM/YYYY HH:mm',
        },
        tooltipFormat: "DD/MM/YYYY HH:mm",
      },

      grid: {
        color: 'rgba(49, 48, 48, 0.5)',
          display: true,
          drawBorder: true, // Dibuja el borde del eje X
          //color: 'rgba(0, 0, 0, 0.1)', // Color de la cuadrícula
          borderColor: 'black', // Color del borde
      },
    },
    y: {
      suggestedMin: minEjeY,//allValor[0].min_grafico,//-10.0, // -1.0,
      suggestedMax: maxEjeY,//rangoEjeY[1]!,//20.0, //allValor![0].max_grafico!,//20.0, //2.0,
      ticks: { 
        color: 'rgb(0,0,0)',
        font: {
          size: window.innerWidth < 600 ? 10 : window.innerWidth < 1200 ? 12 : 14,
          weight: "bold" as const,
        },
      },
      title:{
        text: nombreEjeY,//"Temperatura [°C]" as const,
        display: true,
        font: {
          size: window.innerWidth < 600 ? 14 : window.innerWidth < 1200 ? 16 : 18,
          weight: "bold" as const,
        },
      },
      type: 'linear' as const,
      position: 'left' as const,
      grid: {
        color: 'rgba(49, 48, 48, 0.5)',
       display: true,
       drawBorder: true, // Dibuja el borde del eje X
       //color: 'rgba(0, 0, 0, 0.1)', // Color de la cuadrícula
       borderColor: 'black', // Color del borde
      },
    },
  };

  const zoomOptions = {
    limits: {
      x: {
        min: 'original' as const,
        max: 'original' as const, 
        minRange: 60 * 1000},
      y: {
        min: 'original' as const,
        max: 'original' as const},        
      },
    pan: {
      enabled: zoomEnabled,//true,
      mode: 'x' as const,
      modifierKey: 'ctrl' as const,
      onPan: ({ chart, event }: any) => startFetch(chart, event), //startFetch
    },
  zoom: {
    wheel: {
      enabled: false,//zoomEnabled, //Se desactiva el mouse con la rueda
    },
    drag: {
        enabled: zoomEnabled, //true,//true, // Activamos el zoom por selección de área HACER BOTON
      //  modifierKey: 'ctrl' as const, // Opcional: requiere mantener presionada una tecla
        borderColor: 'rgba(54, 162, 235, 0.5)',
        borderWidth: 1,
        backgroundColor: 'rgba(54, 162, 235, 0.15)',
    },
    pinch: {
      enabled: zoomEnabled,//zoomEnabled,//false,//true
    },
    mode: 'xy' as const,
    onZoomComplete: ({ chart, event }: any) => startFetch(chart, event), //startFetch,
  },
};



  const tituloOptions = {
    display: true,
    position: 'top' as const,
    text: `Gráfico Histórico ${propsCamara.name}`,
    padding: {
      top: 30,
      bottom: 10,
    },
    font: {
      size: window.innerWidth < 600 ? 14 : window.innerWidth < 1200 ? 18 : 22,
      weight: 'bold' as const,
    },    
  }

  const pointOptions = {
      radius: 1,
  }

  const tooltipOtions = {
      mode: 'index' as const,
      intersect: false,
      enabled: tooltipEnabled? true : false, //Oculta o muestra el tooltip HACER BOTON
  }

  const crosshairOptions = {
    line: {
      color: reglaEnabled?'rgba(236, 19, 37, 0.72)':'rgba(0, 0, 0, 0)', //'rgba(0, 0, 0, 0)', // '#F66', //'#999', // color de la línea, si es transparente no se ve 'rgba(0,0,0,0)'
      width: 2,
    },
    sync: {
      enabled: false,
    },
    zoom: {
      enabled: false,
    },
    snap: {
      enabled: false,//true,
    },
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: scales,
    plugins: {
      zoom: zoomOptions,
      title: tituloOptions,
      tooltip: tooltipOtions,
        crosshair: crosshairOptions,
        legend: {
          display: true,
          labels: {
            color: 'rgb(0,0,0)',
            font: {
              size: window.innerWidth < 600 ? 10 : window.innerWidth < 1200 ? 12 : 14,
              weight: "bold" as const,
            },
          },
        }   
    },
    transitions: {
      zoom: {
        animation: {
          duration: 100
        }
      }
    },
    elements: {
      point: pointOptions,
    },
    interaction: {
      mode: 'index' as const,
      intersect: false,
    }
  }
  

  const PanAtras = () => {
    chartRef.current!.pan({x: 100}, undefined, 'default');
  }         
  const PanAdelante = () => {
    chartRef.current!.pan({x: -100}, undefined, 'default');
  }

  const resetZoom = () => {


    if (timerRef.current) 
      clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {

      //Cargamos 1 dia antes 
      // ✅ Actualizamos el estado (React re-renderiza)
      setStartDb(moment().subtract(48, 'hour').toDate());
      setEndDb(moment().toDate());

      //Actualizamos la vista mínima (startChart) al mínimo actual de la escala
      setStartChart(moment().subtract(24, 'hour').toDate());
      setEndChart(moment().toDate());

      try {
        const r = await fetchData(startDb, endDb);
        if (!r || !chartRef.current) return;

        // ✅ Actualizamos el estado React primero
        setValor(r);

        // ✅ Esperamos a que React renderice antes de tocar Chart.js
        requestAnimationFrame(() => {
          const chartInstance = chartRef.current;
          if (
            chartInstance &&
            chartInstance.canvas &&
            chartInstance.canvas.ownerDocument
          ) {
            chartInstance.update("none");
          } else {
            console.warn(
              "⚠️ Chart update skipped because canvas was detached (DevTools open?)"
            );
          }
        });
      } catch (err) 
      {
        console.error("Error updating chart:", err);
      }
    }, 200);

   // chartRef.current!.resetZoom();
  }

  //var Auto: boolean = false;

  const AutoEjeY = () => {

    if(AutoEjeYEnabled === false)
    {
      setAutoEjeYEnabled(true);
      chartRef.current!.options.scales!.y!.suggestedMax = 1;
      chartRef.current!.options.scales!.y!.suggestedMin = 0;
    }
    else
    {
      setAutoEjeYEnabled(false);
      chartRef.current!.options.scales!.y!.suggestedMax = maxEjeY;
      chartRef.current!.options.scales!.y!.suggestedMin = minEjeY;
    }

    chartRef.current!.stop(); // make sure animations are not running
    chartRef.current!.update('none');    
  }

  const toggleZoom = () => setZoomEnabled((prev) => !prev);

  const toggleRegla = () => setReglaEnabled((prev) => !prev);

  const toggleTooltip = () => setTooltipEnabled((prev) => !prev);



  const handleOpenDialog = () => {

    //Carga Fechas de inicio y fin las que aparecen en el grafico
    setTempStart(startChart)
    setTempEnd(endChart)

    setOpenDialog(true);
  };

  const handleApplyDateRange = async () => {

    const inicio = moment(tempStart).toDate();
    const fin = moment(tempEnd).toDate();

    if ((inicio < startChart) || (fin > endChart))
    {
      if (timerRef.current) 
        clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {

        //Cargamos 1 dia antes y un dia despues por si se realiza un scroll
        // ✅ Actualizamos el estado (React re-renderiza)
        setStartDb(moment(inicio).subtract(24, 'hour').toDate());
        setEndDb(moment(fin).add(24, 'hour').toDate());

        //Actualizamos la vista mínima (startChart) al mínimo actual de la escala
        setStartChart(inicio);
        setEndChart(fin);

        try {
          const r = await fetchData(startDb, endDb);
          if (!r || !chartRef.current) return;

          // ✅ Actualizamos el estado React primero
          setValor(r);

          // ✅ Esperamos a que React renderice antes de tocar Chart.js
          requestAnimationFrame(() => {
            const chartInstance = chartRef.current;
            if (
              chartInstance &&
              chartInstance.canvas &&
              chartInstance.canvas.ownerDocument
            ) {
              chartInstance.update("none");
            } else {
              console.warn(
                "⚠️ Chart update skipped because canvas was detached (DevTools open?)"
              );
            }
          });
        } catch (err) 
        {
          console.error("Error updating chart:", err);
        }
      }, 200);
    }

    setLoading(false);
    setOpenDialog(false);

  };


  return (
        <>
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : 
            <>
              <Box
                sx={{
                  //width: "100%",
                  display: 'flex', // Para alinear los botones en fila
                  flexWrap: 'wrap', // Si hay espacio, los botones pueden saltar a la siguiente línea
                  gap: 1, // Espacio entre los botones
                  p: 2,
                  borderRadius: 3,
                  boxShadow: 3,
                  backgroundColor: "#fafafa",
                }}

              >
                  {[
                    { action: PanAtras, title: "Desplazar hacia atras", image: imageFlechaRetrocede },
                    { action: PanAdelante, title: "Desplazar hacia adelante", image: imageFlechaAvanza },
                    { action: resetZoom, title: "Cargar Grafico Original", image: imageInicial },
                    { action: toggleZoom, title: zoomEnabled ? "Desactivar Zoom" : "Activar Zoom", image: imageZoom, borderColor: zoomEnabled ? '4px solid rgba(243, 24, 24, 0.96)' : '2px solid rgba(0, 0, 0, 0.3)' },
                    { action: handleOpenDialog, title: "Seleccionar rango de fechas", image: imageReloj },
                    { action: AutoEjeY, title: AutoEjeYEnabled ? "Desactivar Eje Y Automático": "Activar Eje Y Automático" , image: imageEje, borderColor: AutoEjeYEnabled ? '4px solid rgba(243, 24, 24, 0.96)' : '2px solid rgba(0, 0, 0, 0.3)' },
                    { action: toggleRegla, title: reglaEnabled ? "Desactivar Regla": "Activar Regla", image: imageRegla, borderColor: reglaEnabled ? '2px solid rgba(0, 0, 0, 0.3)' : '4px solid rgba(243, 24, 24, 0.01)' },
                    { action: toggleTooltip, title: tooltipEnabled ? "Desactivar Tooltip" : "Activar Tooltip", image: imagePuntosValores, borderColor: tooltipEnabled ? '2px solid rgba(0, 0, 0, 0.3)' : '4px solid rgba(243, 24, 24, 0.01)' }
                  ].map((button, index) => (
                    <IconButton
                      key={index}
                      onClick={button.action}
                      title={button.title}
                      sx={{
                        width: 40,
                        height: 40,
                        border: button.borderColor || '2px solid rgba(0, 0, 0, 0.3)',
                        borderRadius: 0,
                        backgroundImage: `url(${button.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        '&:hover': {
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)', // Sombra al pasar el mouse
                          transform: 'scale(1.1)', // Efecto de aumento al hacer hover
                        },
                        transition: 'all 0.3s ease-in-out', // Transición suave de la sombra y el tamaño
                      }}
                    />
                  ))}              
                </Box>    
              <div 
                style={{ 
                  width: '100%', 
                 // height: '500px',
                  height: "75vh",
                  margin: '0 auto', 
                  border: '1px solid grey', 
                  padding: '10px' }}>
                <Line
                  ref={chartRef} 
                  options={options} 
                  data={dataValores}
                />
              </div>

              {/* 🗓️ Diálogo para elegir fechas */}
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Seleccionar rango de fechas</DialogTitle>
                <DialogContent 
                  dividers 
                  sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1, pt: 2 }}
                >
                  <TextField
                    label="Fecha y hora inicio"
                    type="datetime-local"
                    value={moment(tempStart).format("YYYY-MM-DDTHH:mm")}
                    onChange={(e) => setTempStart(moment(e.target.value).toDate())}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />

                  <TextField
                    label="Fecha y hora fin"
                    type="datetime-local"
                    value={moment(tempEnd).format("YYYY-MM-DDTHH:mm")}
                    onChange={(e) => setTempEnd(moment(e.target.value).toDate())}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
                  <Button onClick={handleApplyDateRange} variant="contained">Aplicar</Button>
                </DialogActions>
              </Dialog>              
            </>
            }
        </>
    )
}
